<template>
  <WsUpdate
    titleKey="label"
    :label="label"
    :fields="fields"
    :id="$route.params.id"
    :modelName="modelName"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
  />
</template>

<script>
import model from '@/models/contentText';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                fields: [
                  'sequence',
                  'label',
                  'text',
                ],
              },
            ],
          },
      ],
      secondary: [
        {
          type: 'infoCard',
          floors: [
            {
              title: '設定',
              fields: [
                'module',
                'is_user_editable',
                'for',
              ],
            },
          ],
        },
      ],
      },
    };
  },
};
</script>